export default __webpack_public_path__ + "static/media/bjBgLnds.6509ca88.webp";